import { LUCID_PROTOCOL, NOTIFICATION_EVENT_ACTIONS, } from '@lucidlink/workspacemanagement';
export function buildNotificationEventUrl(...[event, params]) {
    switch (event) {
        case NOTIFICATION_EVENT_ACTIONS.OpenFilespace: {
            const { filespaceId, workspaceId } = params;
            return `${LUCID_PROTOCOL}${event}?wsId=${workspaceId}&fsId=${filespaceId}`;
        }
        case NOTIFICATION_EVENT_ACTIONS.OpenFilespaceSnapshots: {
            const { filespaceId, workspaceId } = params;
            return `${LUCID_PROTOCOL}${event}?wsId=${workspaceId}&fsId=${filespaceId}`;
        }
        case NOTIFICATION_EVENT_ACTIONS.OpenFilespaceLocalSettings: {
            const { filespaceId, workspaceId } = params;
            return `${LUCID_PROTOCOL}${event}?wsId=${workspaceId}&fsId=${filespaceId}`;
        }
        case NOTIFICATION_EVENT_ACTIONS.DirectLink: {
            const { encodedEncryptedFileName, encodedFileData, linkFormatVersion, } = params;
            return `${LUCID_PROTOCOL}${event}?linkPath=/l/${linkFormatVersion}/${encodedFileData}/${encodedEncryptedFileName}`;
        }
        case NOTIFICATION_EVENT_ACTIONS.OpenFilespaceUpgrade: {
            const { filespaceId, workspaceId } = params;
            return `${LUCID_PROTOCOL}${event}?wsId=${workspaceId}&fsId=${filespaceId}`;
        }
        case NOTIFICATION_EVENT_ACTIONS.CreateGuestLink: {
            const { filespaceId, fsEntryId, workspaceId } = params;
            return `${LUCID_PROTOCOL}${event}?wsId=${workspaceId}&fsId=${filespaceId}&fsEntryId=${encodeURIComponent(fsEntryId)}`;
        }
        case NOTIFICATION_EVENT_ACTIONS.PinEntries: {
            // https://lucidlink.atlassian.net/browse/LUCID-16535
            throw new Error('FIXME: Desktop-only code should not be in the web client - fix design!');
        }
        case NOTIFICATION_EVENT_ACTIONS.Publish: {
            throw new Error('Publish notification URLs are built by the Finder shell extension, not here.');
        }
    }
}
